import { useQuery } from '@tanstack/react-query';
import { formatterPercentage } from '@/utilities/format';

import { queryFn, getDefaultAverages, getQueryKey } from './queryFn';

import type { CountryISO } from '@/constants/countries';

export const useIndustryMetrics = (
  countryIso2: CountryISO,
  industryId: number,
  enabled?: boolean
) => {
  const { data = getDefaultAverages(), status } = useQuery({
    queryKey: getQueryKey(countryIso2, industryId),
    queryFn,
    staleTime: Infinity,
    enabled,
    refetchOnMount: false,
  });

  return {
    status,
    latestAnalysis: data.latestAnalysis,
    averages: {
      return7D: data.return7D,
      return90D: data.return90D,
      return1YrAbs: data.return1YrAbs,
      return7DFormatted: formatterPercentage(data.return7D),
      return1YrAbsFormatted: formatterPercentage(data.return1YrAbs),
      return90DFormatted: formatterPercentage(data.return90D),
      returnYTD: data.returnYTD,
      returnYTDFormatted: formatterPercentage(data.returnYTD),
    },
  };
};
